import { styled, Typography } from '@mui/material';
import { FC } from 'react';
import { ChatProseFontFamily, ChatProseFontSize, ChatProseLineHeight } from './style-defs';

const UserMessageWrapper = styled('div')`
  display: flex;
  margin: ${({ theme }) => theme.spacing(1, 0)};
  justify-content: flex-end;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const UserMessageBubble = styled('div')`
  max-width: 70%;
  min-width: 100px;
  padding: ${({ theme }) => theme.spacing(3, 4)};
  border-radius: ${({ theme }) =>
    `${theme.spacing(3)} ${theme.spacing(0.5)} ${theme.spacing(0.5)} ${theme.spacing(3)}`};
  background: ${({ theme }) => `${theme.palette.primary.light}38`};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

interface UserMessageProps {
  content: string;
}

export const UserMessage: FC<UserMessageProps> = ({ content }) => {
  return (
    <UserMessageWrapper>
      <UserMessageBubble>
        <Typography
          variant='body2'
          sx={{
            wordBreak: 'break-word',
            fontFamily: ChatProseFontFamily,
            fontSize: ChatProseFontSize,
            lineHeight: ChatProseLineHeight,
          }}
        >
          {content}
        </Typography>
      </UserMessageBubble>
    </UserMessageWrapper>
  );
};
